module.exports = new __parcel__URL__("loading_screen_prog_5.b9d58d7d.png").toString();